export enum ScoreUploaderStep {
  UploadFile = 0,
  MapColumns = 1,
  Confirm = 2,
  Processing = 3,
}
